<div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="file-text"></i> Vehicle Details</h3>
  </div>
  <form [formGroup]="motorInsuredDetailsForm">
    <div class="tab-grid m-t-20">
  
      <div>
        <nz-form-item>
          <nz-form-label nzFor="make" [nzSpan]="24" [nzRequired]="isRequired('make')">Make</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzShowSearch  id="make" (ngModelChange)="getVehicleModel($event)" formControlName="make" style="width: 100%">
              <nz-option
                *ngFor="let item of (lookup$['vehicleMakeCd'] | async) as vehicleMakeCdLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>

          </nz-form-control>
  
        </nz-form-item>
  
  
      </div>
    <nz-form-item>
        <nz-form-label nzFor="model" [nzSpan]="24" [nzRequired]="isRequired('model')">Model</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="model" (ngModelChange)="getVehicleVariant($event)" formControlName="model" style="width: 100%">
            <nz-option
              *ngFor="let item of vehicleModelList; trackBy:item?.modelCd"
              [nzLabel]="item?.modelName" [nzValue]="item?.modelCd"></nz-option>
          </nz-select>

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="variant" [nzSpan]="24" [nzRequired]="isRequired('variant')">Variant</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="variant" (ngModelChange)="getSeatingCapacity($event)" formControlName="variant" style="width: 100%">
            <nz-option
              *ngFor="let item of vehicleVariantList; trackBy:item?.variantCd"
              [nzLabel]="item?.variantName" [nzValue]="item?.variantCd"></nz-option>
          </nz-select>

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="manufacturingDt" [nzSpan]="24" [nzRequired]="isRequired('manufacturingDt')">Manufacturing Year</nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input placeholder="Manufacturing Year" formControlName ="manufacturingDt" />                
        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="entryAge" [nzSpan]="24" [nzRequired]="isRequired('entryAge')">Vehicle Age</nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled" placeholder="Vehicle Age" formControlName ="entryAge" />        

        </nz-form-control>

      </nz-form-item>
  
      <nz-form-item>
        <nz-form-label nzFor="fuelTypeCd" [nzSpan]="24" [nzRequired]="isRequired('fuelTypeCd')">Fuel Type</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="fuelTypeCd" formControlName="fuelTypeCd" style="width: 100%">
            <nz-option
              *ngFor="let item of (lookup$['fuelTypeCd'] | async) as fuelTypeCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="color" [nzSpan]="24" [nzRequired]="isRequired('color')">Color</nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled"placeholder="Color"  formControlName ="color" />        

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="seatingCapacity" [nzSpan]="24" [nzRequired]="isRequired('seatingCapacity')">Seating Capacity</nz-form-label>
        <nz-form-control [nzSpan]="24" >
            <input nz-input class="inputs-are-disabled" formControlName="seatingCapacity" placeholder="Seating Capacity" />        

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="appliedForSeatingCapacity" [nzSpan]="24" [nzRequired]="isRequired('appliedForSeatingCapacity')">No of Covered Passengers
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled" placeholder="No of Covered Passengers" />        

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="bodyType" [nzSpan]="24" [nzRequired]="isRequired('bodyType')">Body Type</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="bodyType" formControlName="bodyType" style="width: 100%">
            <nz-option
              *ngFor="let item of (lookup$['vehicleBodyTypeCd'] | async) as vehicleBodyTypeCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>

        </nz-form-control>

      </nz-form-item>
      
      <nz-form-item>
        <nz-form-label nzFor="eventType" [nzSpan]="24" [nzRequired]="isRequired('eventType')">Sum Insured
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled"placeholder="Sum Insured" />        

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="plateNumber" [nzSpan]="24" [nzRequired]="isRequired('plateNumber')">Plate Number
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled"placeholder="Plate Number" formControlName ="plateNumber" />        

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="ratingType" [nzSpan]="24" [nzRequired]="isRequired('ratingType')">Rating Type</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="ratingType" formControlName="ratingType" style="width: 100%">
            <nz-option
              *ngFor="let item of (lookup$['vehicleRatingTypeCd'] | async) as vehicleRatingTypeCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>

        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="regionCd" [nzSpan]="24" [nzRequired]="isRequired('regionCd')">Region</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="regionCd" formControlName="regionCd" style="width: 100%">
            <nz-option
              *ngFor="let item of (lookup$['mapRegionCd'] | async) as mapRegionCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
        </nz-form-control>

      </nz-form-item>     
      <nz-form-item>
        <nz-form-label nzFor="categoryCd" [nzSpan]="24" [nzRequired]="isRequired('categoryCd')">Category</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch  id="categoryCd" formControlName="categoryCd" style="width: 100%">
            <nz-option
              *ngFor="let item of (lookup$['ageCategoryCd'] | async) as ageCategoryCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
        </nz-form-control>

      </nz-form-item>   
      <nz-form-item>
        <nz-form-label nzFor="engineNum" [nzSpan]="24" [nzRequired]="isRequired('engineNum')">Engine Number
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled"placeholder="Engine Number" formControlName ="engineNum" />        

        </nz-form-control>

      </nz-form-item>
      <nz-form-item>
        <nz-form-label nzFor="chasisNum" [nzSpan]="24" [nzRequired]="isRequired('chasisNum')">Chasis Number
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
            <input nz-input class="inputs-are-disabled" placeholder="Chasis Number" formControlName ="chasisNum" />        

        </nz-form-control>

      </nz-form-item>
    </div>
  
    <!-- Dates -->
    <div class="tab-grid">
  
    </div>
  </form>
